/* eslint-disable react/prop-types */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import _ from 'lodash/fp';
import React, { useCallback, useContext, useMemo } from 'react';
import { Dropdown } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { isEmpty, isNil, noop } from 'lodash';
import { AREA_TYPE, AREA_TYPE_CONFIG, PRODUCT_TYPE } from '../../constants/product';
import { showModal } from '../../redux/actions';
import text, { formatSqmArea } from '../../text';
import { selectionChildren } from '../../utilities/map';
import DropdownItemLabel from '../dropdown/DropdownItemLabel';
import Submenu from '../dropdown/Submenu';
import { getAddOnConfig } from '../mapView/drawingManager/utilities';
import { computePerimeter } from '../mapView/geometry';
import DownloadsMenu from '../mapView/layersPanel/DownloadsMenu';
import { MapViewContext } from '../mapView/mapViewContext';
import { DELETE_SHAPES_MODAL } from '../modal/DeleteShapesModal';
import ProductMenu from '../productMenu/ProductMenu';
var SQM_IN_SQKM = 1e6;
// ShapeMenuContent should be inside of a react-bootstrap <Dropdown.Menu /> component
// Also must be within a <MapViewContext.Provider /> to access the context
export default function ShapeMenuContent(param) {
    var data = param.data, showShapeName = param.showShapeName, _param_areaType = param.areaType, areaType = _param_areaType === void 0 ? AREA_TYPE.PRODUCT_AREA : _param_areaType, _param_popupTrigger = param.popupTrigger, popupTrigger = _param_popupTrigger === void 0 ? '' : _param_popupTrigger, _param_closeMenu = param.closeMenu, closeMenu = _param_closeMenu === void 0 ? noop : _param_closeMenu, _param_closeDropdownOnSelect = param.closeDropdownOnSelect, closeDropdownOnSelect = _param_closeDropdownOnSelect === void 0 ? true : _param_closeDropdownOnSelect;
    var _state_selectionProductAvailability;
    var dispatch = useDispatch();
    var _useContext = useContext(MapViewContext), actions = _useContext.actions, state = _useContext.state;
    var _AREA_TYPE_CONFIG_areaType = AREA_TYPE_CONFIG[areaType], area_type_key = _AREA_TYPE_CONFIG_areaType.key, area_type_label = _AREA_TYPE_CONFIG_areaType.label;
    var handleCloseMenu = useCallback(function() {
        return !!closeMenu && closeMenu();
    }, [
        closeMenu
    ]);
    var coverage = useMemo(function() {
        return _.find([
            'selection_id',
            data.id
        ], state.coveragePerProduct[data.category_name]);
    }, [
        state.coveragePerProduct,
        data
    ]);
    var shapeArea = useMemo(function() {
        if (!isEmpty(coverage) && !isNil(coverage[area_type_key])) {
            if (coverage[area_type_key] > SQM_IN_SQKM) {
                return "".concat((coverage[area_type_key] / SQM_IN_SQKM).toLocaleString(undefined, {
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1
                }), " km\xb2");
            }
            return formatSqmArea(coverage[area_type_key]);
        }
        return '';
    }, [
        area_type_key,
        coverage
    ]);
    var handleToggleVisibility = useCallback(function() {
        actions.toggleSelectionVisibility(data.id, closeDropdownOnSelect);
        closeDropdownOnSelect && handleCloseMenu();
        // If from LHS(left-hand-side) Menu
        if (popupTrigger === 'LHS') {
            // empty product selected to remove right-menu product activeClass
            actions.setProductSelected({});
        }
        // for ShapeMenuModal(in cart) -> update Show/Hide icon & name
        actions.setOpenedShapeMenu(function(prev) {
            if (prev && prev.data) {
                return _object_spread_props(_object_spread({}, prev), {
                    data: _object_spread_props(_object_spread({}, prev.data), {
                        visible: !prev.data.visible
                    })
                });
            }
            return prev;
        });
    }, [
        actions,
        closeDropdownOnSelect,
        data.id,
        handleCloseMenu,
        popupTrigger
    ]);
    var handleDelete = useCallback(function() {
        handleCloseMenu();
        var childShapes = state.selections.filter(function(selection) {
            return selection.parent_selection_id === data.id;
        });
        var selectionsToDelete = [
            data
        ].concat(_to_consumable_array(childShapes));
        dispatch(showModal(DELETE_SHAPES_MODAL, {
            selectionsToDelete: _to_consumable_array(selectionsToDelete).concat(_to_consumable_array(childShapes)),
            associatedAddOns: childShapes
        }));
    }, [
        data,
        dispatch,
        handleCloseMenu,
        state.selections
    ]);
    var draftData = _.find([
        'category_name',
        'unknown'
    ], (_state_selectionProductAvailability = state.selectionProductAvailability) === null || _state_selectionProductAvailability === void 0 ? void 0 : _state_selectionProductAvailability[data.id]);
    var isDraft = data.category_name === PRODUCT_TYPE.UNKNOWN;
    var canRemoveFromCart = !isDraft && !!draftData;
    var removeFromCart = function() {
        var _state_activeSelection;
        var fn = function() {
            var isAddOn = !!getAddOnConfig(data.category_name);
            actions.changeSelectionProductType(data.id, draftData, {}, isAddOn && !!data.parent_selection_id ? data.id : null);
            if (state.showProductModal) {
                actions.clearProductSelected();
            }
        };
        var activeSelectionChildren = selectionChildren(state.selections, ((_state_activeSelection = state.activeSelection) === null || _state_activeSelection === void 0 ? void 0 : _state_activeSelection.id) || data.id);
        if (activeSelectionChildren.length > 0) {
            actions.showChangeProductTypeConfirmation(data.category_name, activeSelectionChildren, function() {
                fn();
            }, true);
        } else {
            fn();
        }
    };
    var selectionPerimeter = (data === null || data === void 0 ? void 0 : data.region) ? computePerimeter(data.region.include, data.region.exclude) : null;
    var handleDuplicateSelection = function() {
        actions.duplicateSelection(data, {
            makeDuplicatedSelectionActive: true
        });
        closeDropdownOnSelect && handleCloseMenu();
    };
    var shouldCollapsedProductSubmenu = useMemo(function() {
        // when no selected shape menu from cart, submenu is collapsed
        if (!state.openedShapeMenu.data) {
            return true;
        }
        var _state_openedShapeMenu = state.openedShapeMenu, category_name = _state_openedShapeMenu.data.category_name, prevCategoryName = _state_openedShapeMenu.prevCategoryName;
        // if shape data category has no changes, submenu is collapased otherwise expanded
        return category_name === prevCategoryName;
    }, [
        state.openedShapeMenu
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Dropdown.Header, null, showShapeName ? /*#__PURE__*/ React.createElement("div", {
        className: "shape-name"
    }, /*#__PURE__*/ React.createElement("p", {
        className: "font-weight-bold mb-0 font-16"
    }, data.name)) : null, /*#__PURE__*/ React.createElement("div", {
        className: "area-section"
    }, "".concat(area_type_label, ": ").concat(shapeArea), selectionPerimeter ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("br", null), "Perimeter: ".concat(formatSqmArea(selectionPerimeter))) : null)), /*#__PURE__*/ React.createElement(Dropdown.Divider, null), /*#__PURE__*/ React.createElement(Dropdown.Item, {
        onClick: handleToggleVisibility
    }, /*#__PURE__*/ React.createElement(DropdownItemLabel, {
        label: !data.visible ? text('showShape') : text('hideShape'),
        icon: !data.visible ? 'eye' : 'eye-slash'
    })), /*#__PURE__*/ React.createElement(Dropdown.Item, {
        onClick: function() {
            actions.zoomToShapeExtents(data);
            closeDropdownOnSelect && handleCloseMenu();
        }
    }, /*#__PURE__*/ React.createElement(DropdownItemLabel, {
        label: text('zoomExtents'),
        icon: "zoom_extents"
    })), /*#__PURE__*/ React.createElement(Dropdown.Item, {
        onClick: handleDuplicateSelection
    }, /*#__PURE__*/ React.createElement(DropdownItemLabel, {
        icon: "duplicate",
        label: text('duplicateShape')
    })), /*#__PURE__*/ React.createElement(Submenu, {
        className: "customPadded",
        label: text('download2dShape'),
        menuIcon: "file-download"
    }, /*#__PURE__*/ React.createElement(DownloadsMenu, {
        closeOnSelect: closeDropdownOnSelect,
        handleCloseMenu: handleCloseMenu,
        selections: [
            data
        ]
    })), /*#__PURE__*/ React.createElement(Dropdown.Divider, null), /*#__PURE__*/ React.createElement(Submenu, {
        className: "customPadded",
        label: text(isDraft ? 'addToCart' : 'changeTypeInCart'),
        menuIcon: isDraft ? 'add-on' : 'change-type',
        collapsed: shouldCollapsedProductSubmenu
    }, /*#__PURE__*/ React.createElement(ProductMenu, {
        data: data,
        closeOnSelect: closeDropdownOnSelect
    })), canRemoveFromCart ? /*#__PURE__*/ React.createElement(Dropdown.Item, {
        onClick: removeFromCart
    }, /*#__PURE__*/ React.createElement(DropdownItemLabel, {
        icon: "unknown",
        label: text('removeFromCart')
    })) : null, /*#__PURE__*/ React.createElement(Dropdown.Divider, null), /*#__PURE__*/ React.createElement(Dropdown.Item, {
        onClick: handleDelete
    }, /*#__PURE__*/ React.createElement(DropdownItemLabel, {
        label: text('deleteShape'),
        icon: "trash",
        className: "danger-button"
    })));
}
